<template>
  <div class="page">
    <c-source-detail
      :columns="columns"
      :data="data"
      resource="commission_settlement_applications"
    />
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import createColumns from './columns';

@Component
export default class CommissionSettlementApplicationDetail extends Vue {
  data = {}

  get columns() {
    const columns = createColumns({
      handleTransferSuccess: this.handleTransferSuccess,
      handleRejectSuccess: this.handleRejectSuccess
    });
    Object.assign(columns[columns.length - 1], {
      detail: false,
      action: []
    });
    return columns;
  }

  async mounted() {
    this.data = await this.$request.get(`/commission_settlement_applications/${this.$route.params.id}`);
  }

  handleTransferSuccess() {
    Object.assign(this.data, { status: 'transfer_processing' });
  }

  handleRejectSuccess() {
    Object.assign(this.data, { status: 'rejected' });
  }
}
</script>
